/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './module-logo.reducer';

export const ModuleLogoDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const moduleLogoEntity = useAppSelector(state => state.moduleLogo.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="moduleLogoDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.moduleLogo.detail.title">ModuleLogo</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.id">Id</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.id}</dd>
          <dt>
            <span id="path">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.path">Path</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.path}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.entityId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.active">Active</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.moduleLogo.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{moduleLogoEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/module-logo" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/module-logo/${moduleLogoEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ModuleLogoDetail;
